import VM from '@src/mobx-store/vm/view-model';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import { CAPTCHA_PRE_AUTH } from '@src/constants';
import Services from '@src/services/general';
import routeConfigs from '@src/pages/app-router/route-configs';
import reload from '@src/utils/reload';

export default class LoginVM extends VM {
  static getInitialProps = async () => {
    return {};
  };

  /**
   * 页面状态
   * @type {{}}
   */
  viewState = {
    //账号
    account: undefined,
    //密码
    password: undefined,
    //页面跳转
    urlType: undefined
  };

  async $$componentDidMount() {
    const param = this.getRouteQueryParams();
    const { type } = param;
    this.viewState.urlType = type;
    // await this.getCurrentAccount();
    const currentAccount = this.$rootStore.globalStore.currentAccount;
    if (currentAccount) {
      this.redirect(routeConfigs.MAIN.getFormatPath());
    }
  }

  /**
   * 推导类型
   * @type {{}}
   */
  computes = {
    // get isValid() {
    //   return Number(this.viewState.inputStore.value) > 100;
    // }
  };

  /**
   * 数据映射
   */
  mappers = {
    // /**
    //  * @this {MainVM}
    //  */
    // mapBusinessExampleNewsItems(items) {
    //   debugger;
    //   return Object.keys(items).map(key => {
    //     const item = items[key];
    //     return {
    //       des: item.description,
    //       title: item.title,
    //       onClick: () => {
    //         this.entry.onButtonClick({ id: item.id });
    //       }
    //     };
    //   });
    // }
  };

  /**
   * 入口函数
   */
  entry = {
    /**
     * 输入
     * @param type
     * @param v
     */
    onValueChange(type, v) {
      // let value = v.replace(/\s+/g, '');
      switch (type) {
        case 'account':
          this.viewState.account = v;
          break;
        case 'password':
          this.viewState.password = v;
          break;
        default:
          break;
      }
    },
    async onSubmit() {
      let isValid = this.validVerifyAccount();
      isValid && (await this.onLoginClick());
    }
  };

  /**
   * 校验账号和密码
   * @returns {boolean}
   */
  validVerifyAccount() {
    let isValid = false;
    const { account, password } = this.viewState;
    if (!account) {
      alert('账号不能为空');
    } else if (!password) {
      alert('密码不能为空');
    } else {
      isValid = true;
    }
    return isValid;
  }

  /**
   * 登录
   * @param type
   */
  @captchaHandlerDecorate()
  async onLoginClick({ ...authParams }) {
    const { account, password } = this.viewState;
    await Services.login({ account, password, ...authParams })
      .then(data => {
        setTimeout(() => {
          reload();
        });
        // console.info('登录返回', data);
      })
      .catch(err => {
        const errCode = err.serviceResponse.code;
        // console.info(err, errCode);
        if (errCode === -12840 /*账号或者密码错误*/) {
          this.viewState.password = '';
        }
        const errMsg = err.serviceResponse.message;
        alert(errMsg);
      });
  }

  /**
   * 获取登录信息
   * @returns {Promise<void>}
   */
  // async getCurrentAccount() {
  //   await Services.getCurrentAccount()
  //     .then(data => {
  //       if (data.data && data.data.account) {
  //         const { urlType } = this.viewState;
  //         if (urlType === 'bindPhone') {
  //           this.redirect(routeConfigs.MAIN.getFormatPath());
  //         } else if (urlType === 'updatephone') {
  //           this.redirect(routeConfigs.UPDATEPHONE.getFormatPath());
  //         }
  //       }
  //     })
  //     .catch(err => {
  //       if (err && err.serviceResponse) {
  //         const errCode = err.serviceResponse.code;
  //         if (errCode !== -13403 /*未登录*/) {
  //           const errMsg = err.serviceResponse.message;
  //           alert(errMsg);
  //         }
  //       }
  //     });
  // }
}



// WEBPACK FOOTER //
// ./src/pages/login/vm.js